import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

/**
 * AnimatedCounter
 * Props:
 *   value: numeric target
 *   prefix, suffix
 *   duration: ms
 *   decimals
 */
export default function AnimatedCounter({
  value = 0,
  prefix = "",
  suffix = "",
  duration = 1600,
  decimals = 0,
  className = "",
  testId,
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start;
    const from = 0;
    const to = Number(value) || 0;
    const step = (t) => {
      if (!start) start = t;
      const p = Math.min(1, (t - start) / duration);
      // easeOutCubic
      const e = 1 - Math.pow(1 - p, 3);
      setN(from + (to - from) * e);
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [inView, value, duration]);

  const formatted = decimals
    ? n.toFixed(decimals)
    : Math.round(n).toLocaleString();

  return (
    <span ref={ref} data-testid={testId} className={className}>
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
}
